module.exports = __webpack_public_path__ + "static/media/keyword-in-header-one.9c5ac322.svg";